import React from "react";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { resetDocReponse } from "../../store/Checkin/Scan/documentScanSlice";
import {
  formatDate,
  nameValidation,
  addPrefixIfSingleLetter,
} from "../../helpers/commonHelper";
import moment from "moment";
import { TitleCaseConverter } from "../Plugins/TitleCaseCoverter";
import { getParametersFromLocalStorage } from "../../helpers/commonHelper";
import { getAllUpsellPackages, GetPackagesMaster } from "../../network/apiService";
const findNumberOfNights = (arrivalDate, departureDate) => {
  let noOfNights = null;
  if (arrivalDate && departureDate) {
    const date1 = new Date(moment(arrivalDate).format("YYYY-MM-DD"));
    const date2 = new Date(moment(departureDate).format("YYYY-MM-DD"));
    const timeDiff = date2.getTime() - date1.getTime();
    const nights = Math.ceil(timeDiff / (1000 * 3600 * 24));
    noOfNights = nights;
  }
  return noOfNights;
};
export function RoomType(reservationData) {
  const { t } = useTranslation();

  return (
    <div>
      <label className="reservation-card-label">{t("Room Type")}:</label>
      <div>
        <p>{reservationData?.reservationData?.roomTypeDescription}</p>
      </div>
    </div>
  );
}

export function ArrivalDate(reservationData) {
  const { t } = useTranslation();
  return (
    <div className="col-4" style={{ margin: 0, whiteSpace: "nowrap" }}>
      <label className="reservation-card-label">{t("Arrival Date")}:</label>
      <div>
        <p>{formatDate(reservationData?.reservationData?.arrivalDate)}</p>
      </div>
    </div>
  );
}
export function DepartureDate(reservationData) {
  const { t } = useTranslation();
  return (
    <div className="col-4" style={{ margin: 0, whiteSpace: "nowrap" }}>
      <label className="reservation-card-label">{t("Departure Date")}:</label>
      <div>
        <p>
          {formatDate(reservationData?.reservationData?.departureDate) || ""}
        </p>
      </div>
    </div>
  );
}
export function Name(reservationData) {
  const { t } = useTranslation();

  return (
    <div>
      <label className="reservation-card-label">{t("Name")}:</label>
      <div><p>
        {TitleCaseConverter({
          text:
            (reservationData?.reservationData?.title !== "" &&
            reservationData?.reservationData?.title !== null
              ? reservationData?.reservationData?.title?.includes(".")
                ? reservationData?.reservationData?.title + " "
                : reservationData?.reservationData?.title + "." + " "
              : "") +
            reservationData?.reservationData?.firstName +
            " " +
            reservationData?.reservationData?.lastName,
        })}
        </p>
      </div>
    </div>
  );
}
export function NoOfNights(reservationData) {
  const { t } = useTranslation();
  return (
    <div className="col-4" style={{ margin: 0, whiteSpace: "nowrap" }}>
      <label className="reservation-card-label">{t("Number of Nights")}:</label>
      <div>
        <p>
          {addPrefixIfSingleLetter(
            findNumberOfNights(
              reservationData?.reservationData?.arrivalDate,
              reservationData?.reservationData?.departureDate
            ) + ""
          )}
        </p>
      </div>
    </div>
  );
}

export function AdultCount(reservationData) {
  const { t } = useTranslation();
  return (
    <div className="col-4" style={{ margin: 0, whiteSpace: "nowrap" }}>
      <label className="reservation-card-label">{t("Adult(s)")}:</label>
      <div>
        <p>{reservationData?.reservationData?.adultCount}</p>
      </div>
    </div>
  );
}
export function ChildCount(reservationData) {
  const { t } = useTranslation();
  return (
    <div className="col-4" style={{ margin: 0, whiteSpace: "nowrap" }}>
      <label className="reservation-card-label">
        {t("Children (0-12years old)")}:
      </label>
      <div>
        <p>{reservationData?.reservationData?.childCount || 0}</p>
      </div>
    </div>
  );
}

export async function hasBreakfastPackage(reservationData) {
  const token = getParametersFromLocalStorage("token");
  const ReservationNameID = localStorage.getItem("reservationNameID");

  const response = await GetPackagesMaster(token);

  if (
    response?.status === 200 &&
    Array.isArray(response?.data?.data) &&
    response.data.data.length > 0
  ) {
    const upgradePackages = response.data.data; // From DB
    const reservationPackages = reservationData?.packages || [];
   

    const dbPackageCodes = upgradePackages
      .filter((pkg) => pkg.packageType === "BF")
      .map((pkg) => pkg.packageCode?.toUpperCase())
      .filter(Boolean);

    const reservationPackageCodes = reservationPackages
      .map((pkg) => pkg.packageCode?.toUpperCase())
      .filter(Boolean);

    const hasCodeMatch = dbPackageCodes.some((code) =>
      reservationPackageCodes.includes(code)
    );
   

    return hasCodeMatch;
  }

  return false;
}

export function Breakfast({ reservationData }) {
  const { t } = useTranslation();
  const [breakfastIncluded, setBreakfastIncluded] = useState(false);

  useEffect(() => {
    async function checkBreakfast() {
      const result = await hasBreakfastPackage(reservationData);
      setBreakfastIncluded(result);
    }

    checkBreakfast();
  }, [reservationData]);

  return (
    <div className="breakfast-info">
      <label className="reservation-card-label">{t("Breakfast")}:</label>
      <p>
        {breakfastIncluded
          ? t("Breakfast Included")
          : t("Breakfast Not Included")}
      </p>
    </div>
  );
}

export function MembershipNumber({ reservationData }) {
  const { t } = useTranslation();
    // Get array of membership entries
  const memberships = reservationData?.membership || [];

  // Get the first membership (if any)
  const firstMembership = memberships[0];
  
  return (
    <div className="membership-number">
      <label className="reservation-card-label">{t("Membership Number")}:</label>
      <p>
       {firstMembership?.membershipNumber || t("No Active Membership")}
      {/* {firstMembership?.membershipID || t("No Active Membership")} */}
      </p>
    </div>
  );
}

export function MembershipID({ reservationData }) {
  const { t } = useTranslation();
    // Get array of membership entries
  const memberships = reservationData?.membership || [];

  // Get the first membership (if any)
  const firstMembership = memberships[0];
  
  return (
    <div className="membership-id">
      <label className="reservation-card-label">{t("Membership ID")}:</label>
      <p>
       {/* {firstMembership?.membershipNumber || t("No Active Membership")} */}
      {firstMembership?.membershipID || t("No Active Membership")}
      </p>
    </div>
  );
}

export function MembershipLevel({ reservationData }) {
  const { t } = useTranslation();
    // Get array of membership entries
  const memberships = reservationData?.membership || [];
  // Get the first membership (if any)
  const firstMembership = memberships[0];
  
  return (
    <div className="membership-number">
      <label className="reservation-card-label">{t("Membership Level")}:</label>
      <p>
       {firstMembership?.membershipLevel || t("No Active Membership")}
      </p>
    </div>
  );
}
